import { PureComponent } from 'react'
// import PropTypes from 'prop-types'

class Tournaments extends PureComponent {
  render() {
    return <div>Tournaments</div>
  }
}

Tournaments.propTypes = {}

Tournaments.defaultProps = {}

export class Pure extends Tournaments {}
Pure.displayName = 'Tournaments'

export default Tournaments
